<template>
  <div>
    <div class="flex justify-between w-full">
      <div class="text-3xl mb-8">Bestellungen</div>
    </div>

    <OrderTable />
  </div>
</template>

<script>
import OrderTable from "@/components/OrderTable";

export default {
  components: { OrderTable },
};
</script>